import { render, staticRenderFns } from "./invite-add-or-update.vue?vue&type=template&id=a2edc306&scoped=true&"
import script from "./invite-add-or-update.vue?vue&type=script&lang=js&"
export * from "./invite-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2edc306",
  null
  
)

export default component.exports